import { RootState } from '../../rootReducer';

export const getFilterSettings = ({ filter }: RootState) => filter;
